The input parameter for the `closePostedPositionProfile` mutation.
